import { render, staticRenderFns } from "./checkManageMentDetailSort.vue?vue&type=template&id=4cd4e3d7&"
import script from "./checkManageMentDetailSort.vue?vue&type=script&lang=js&"
export * from "./checkManageMentDetailSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports